import React from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"

const EButtonDetailsModal = props => {
  const { isOpen, toggle, eButton } = props
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>e-button Details</ModalHeader>
        <ModalBody>
          <p className="mb-4">
            Label: <span className="text-primary">{eButton?.label}</span>
          </p>
          <p className="mb-4">
            Description: <span className="text-primary">{eButton?.description}</span>
          </p>
          <p className="mb-4">
            Message: <span className="text-primary">{eButton?.message}</span>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

EButtonDetailsModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  eButton: PropTypes.object,
}

export default EButtonDetailsModal
